export default __webpack_public_path__ + "images/models/62f85f3b1e001aab8b2df06b65525639.glb";